(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/gameguide/assets/javascripts/game-guide-view.js') >= 0) return;  svs.modules.push('/components/components/gameguide/assets/javascripts/game-guide-view.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.components.gameguide.GameGuideView = Marionette.View.extend({
    template() {
      return '<div id="spelguide-tabview"></div>';
    },
    tabView: undefined,
    id: 'view-spelguide',
    initialize() {
      if (this.options.tabViews.length === 0) {
        return;
      }
      this.tabViews = this.options.tabViews.map(tabView => ({
        caption: tabView.title,
        id: tabView.name,
        view: new svs.components.gameguide.GameGuideArticle({
          model: new Backbone.Model(tabView)
        })
      }));
    },
    onRender() {
      const self = this;
      this.tabView = new svs.components.Tabs({
        tabs: this.tabViews,
        el: this.$('#spelguide-tabview'),
        selected: 'om-challenge'
      });
      this.tabView.on('onChange', () => {
        self.trigger('modalContentResize');
      });
    }
  });
})(Backbone, _, svs);

 })(window);